import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    hardBlockConfirm: 'Se over og bekreft',
    hardBlockConfirmInfoText1: 'Du har valgt å sperre kortnummer {} ',
    hardBlockConfirmInfoNoReorder: 'Nytt kort er ikke bestilt.',
    blockStatusHard: 'Kortet er permanent sperret',
    blockStatusReordered: 'Kortet er erstattet',
    blockStatusReorderedSuffix: 'og rebestilt',
    reorderingNotAvailableMessage: 'Rebestilling av kort er midlertidig utilgjengelig.',
    orderCardStep0Description: 'Du får nytt kort om 5-7 virkedager.',
    orderCardErrorBlockCardSuccess:
        'Kortet er sperret, men noe gikk galt med bestillingen av et nytt kort. Ta kontakt med banken din for å fullføre bestillingen.',
    messageErrorUps: 'Ojsann!',
    orderBankCardFailureText: 'Noe gikk feil, vent litt og prøv igjen.',
    genericErrorHeader: 'Vi beklager',
    blockError: 'Noe gikk galt under sperring av kort. Vennligst prøv igjen senere.',
    blockAreYouSureBlock: 'Ja, sperr kortet',
    confirmBySmsText: 'Det blir sendt bekreftelse på SMS til mobilnummer',
    confirmBySmsText2: 'Vi har sendt en SMS-bekreftelse til mobilnummer',
    blockConfirmToAccountNumber: 'til kontonummer',
    formCancel: 'Avbryt',
    formOk: 'Ok',
    blockStep2Legend: 'Vil du bestille nytt kort?',
    blockTitle: 'Sperr kort',
    blockReplaceTitle: 'Sperr/erstatt kort',
    formBack: 'Tilbake',
    formNext: 'Neste',
    blockPriceListLink: 'Se prisliste for kort',

    reorderOptionYes: 'Ja, jeg vil bestille nytt kort',
    reorderOptionNo: 'Nei, jeg vil ikke bestille nytt kort',

    blockReason_LOST: 'Jeg har mistet det',
    blockReason_STOLEN: 'Kortet er stjålet',
    blockReason_UNAUTHORIZED_USE: 'Kortet er misbrukt av andre',
    blockReason_ABUSE: 'Kortet er misbrukt',
    blockReason_OTHER: 'Andre årsaker',

    unauthorisedUseCardInfo:
        'Ettersom kortet er misbrukt av andre, må du ta kontakt med vårt kundesenter for å få bestilt nytt kort. Du vil også få nyttig veiledning om hva du bør gjøre videre.',
};

export default fallbackDictionary;
